'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CitcatLinks = exports.CitcatLinksUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _msaSearchHashes = require('constants/msa-search-hashes');

var _multitrack = require('helpers/multitrack');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CitcatLinksUnwrapped = exports.CitcatLinksUnwrapped = function (_Component) {
  (0, _inherits3.default)(CitcatLinksUnwrapped, _Component);

  function CitcatLinksUnwrapped() {
    (0, _classCallCheck3.default)(this, CitcatLinksUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (CitcatLinksUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CitcatLinksUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(CitcatLinksUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Sell Experience', 'View Module', 'CitcatLinks', 0, { nonInteraction: true });
    }
  }, {
    key: 'formatMsa',
    value: function formatMsa(msa) {
      return msa.replace(/\b[a-z]([a-z]$|)/g, function (x) {
        return x.toUpperCase();
      }).replace(/-/g, ' ');
    }
  }, {
    key: 'renderSection',
    value: function renderSection(region, cities, comingSoon) {
      var _this = this;

      var regionName = region.replace(/\b[a-z]/g, function (x) {
        return x.toUpperCase();
      }).replace('-', ' ');
      var comingSoonList = comingSoon || [];
      return _react2.default.createElement(
        'div',
        { key: region, className: 'grid__item 1/2 md-1/3 lg-1/6 color-text-light' },
        _react2.default.createElement(
          'h6',
          { className: 'mb-' },
          regionName
        ),
        _react2.default.createElement(
          'ul',
          { className: 'mb' },
          cities.map(function (msa) {
            return _this.renderLink(msa);
          }),
          comingSoonList.map(function (msa) {
            return _this.renderComingSoon(msa);
          })
        )
      );
    }
  }, {
    key: 'renderLink',
    value: function renderLink(msa) {
      var msaLink = '/venues/' + _msaSearchHashes.MSA_SEARCH_HASHES[msa.replace(/\./g, '')];
      var msaName = this.formatMsa(msa);
      return _react2.default.createElement(
        'li',
        { key: msa },
        _react2.default.createElement(
          'a',
          {
            className: 'block pv-- color-text-light',
            href: msaLink,
            onClick: function onClick() {
              return (0, _multitrack.ga)('Sell Experience', 'Click MSA CitCat Link', msaName, '1');
            }
          },
          msaName
        )
      );
    }
  }, {
    key: 'renderComingSoon',
    value: function renderComingSoon(msa) {
      var msaName = this.formatMsa(msa);
      return _react2.default.createElement(
        'li',
        { className: 'pv-- color-text-light', key: msa },
        msaName,
        ' (Coming soon)'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // TODO i18n
      var locations = [['east-coast', ['baltimore', 'boston', 'new-york', 'philadelphia', 'pittsburgh', 'washington-d.c.']], ['southeast', ['atlanta', 'charlotte', 'miami', 'nashville', 'new-orleans', 'orlando', 'raleigh', 'tampa']], ['midwest', ['chicago', 'cincinnati', 'columbus', 'denver', 'indianapolis', 'kansas-city', 'milwaukee', 'minneapolis', 'st.-louis']], ['west-coast', ['honolulu', 'inland-empire', 'los-angeles', 'missoula', 'portland', 'sacramento', 'salt-lake-city', 'san-diego', 'san-francisco', 'seattle']], ['southwest', ['austin', 'dallas', 'houston', 'las-vegas', 'phoenix', 'san-antonio']], ['international', ['adelaide', 'brisbane', 'bristol', 'calgary', 'hong-kong', 'london', 'malaysia', 'manchester', 'melbourne', 'new-zealand', 'perth', 'singapore', 'sydney', 'thailand', 'toronto', 'united-arab-emirates', 'vancouver']]];
      return _react2.default.createElement(
        'div',
        { className: 'citcat-links bg--' + (this.props.backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'wrap ph pt+ pb md-ph+ md-pv++' },
          _react2.default.createElement(
            'h2',
            { className: 'gamma text--center mb+' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'citcat.header',
              defaultMessage: 'Some of our top locations'
            })
          ),
          _react2.default.createElement('hr', { className: 'mt mb+ md-hidden' }),
          _react2.default.createElement(
            'div',
            { className: 'grid' },
            locations.map(function (section) {
              return _this2.renderSection(section[0], section[1], section[2]);
            })
          )
        )
      );
    }
  }]);
  return CitcatLinksUnwrapped;
}(_react.Component);

CitcatLinksUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['white', 'light'])
};

var CitcatLinks = exports.CitcatLinks = (0, _TrackDwell2.default)(CitcatLinksUnwrapped);